/**
 * Uplifted from `helper/localServer` — WEB/electron half.
 */
import { prepareLsPayloadData } from "./shared";
import store from "../../redux-store";
import { getLocalStorage } from "../../utils/localStorage";
import { DEVICEIDENTIFIER } from "../../utils/constants";
import { getVersionNumber } from "../versionHelper";
import {
  MIN_NW_APP_VERSION_SUPPORTED,
  NW_APP_LATEST_STABLE_VERSION,
} from "../../data/constants";

export * from "./shared";

/**
 * Builds the payload web's `utils/OfflineUtil` POSTs to the LAN master, in one of two shapes
 * depending on how old the NW-app shell is: modern shells (`LS_BRIDGE` <= version <= latest
 * stable) get `[{ path, serverAddress, dataToSend: {deviceIdentifier, message} }]` — an ARRAY —
 * while older ones get a bare object whose `dataToSend` is a URL-encoded JSON string.
 *
 * ⚠️ **The array-vs-object return is load-bearing and easy to "tidy" away.** Both shapes are
 * returned from the same function and the callers pass them straight to the native bridge.
 * The probe asserts both branches by driving `getVersionNumber` through localStorage.
 *
 * ⚠️ Web-only: mobile has neither the NW-app version gates nor a `versionHelper`.
 *
 * ⚠️ Deep-imports `../versionHelper/index.desktop` and `../../data/constants/index.desktop`
 * (hazard 6/16): this file knows its platform, and neither module has a `.native` sibling that
 * exports these symbols — a bare folder import would make `packages/core`'s own tsc resolve
 * against `.native` under `moduleSuffixes` and fail with TS2614.
 *
 * The two `console.log`s are preserved verbatim from apps/web, typos included — they are how
 * this path is debugged on real terminals, and craco strips them from prod builds anyway.
 */
export function getLSRequestPayloadData(path: string, message: any = {}) {
  const posPreferences = store.getState().catalogStore?.posSettings || {};
  const versionNumber = getVersionNumber();
  const isSuitableVersion =
    !isNaN(versionNumber) &&
    versionNumber >= MIN_NW_APP_VERSION_SUPPORTED.LS_BRIDGE &&
    versionNumber <= NW_APP_LATEST_STABLE_VERSION;
  console.log("kkllk----posSettingsFromLs=", posPreferences);
  const serverAddress = posPreferences?.localServer?.address;
  console.log("kkllk----serverAddress=", serverAddress);
  // getState().catalogStore?.posSettings?.localServer?.address;
  let payloadData: Record<string, any> = {
    path,
    serverAddress,
  };
  if (isSuitableVersion) {
    payloadData.dataToSend = prepareLsPayloadData(message);
    return [payloadData];
  }
  let params = {
    deviceIdentifier: getLocalStorage(DEVICEIDENTIFIER),
    message,
  };
  payloadData.dataToSend = encodeURIComponent(JSON.stringify(params));
  return payloadData;
}
